<template>
  <div class="comwrap">
    <div class="calendar-hd">
      <ul>
        <li class="weekend">日</li>
        <li>一</li>
        <li>二</li>
        <li>三</li>
        <li>四</li>
        <li>五</li>
        <li class="weekend">六</li>
      </ul>
    </div>
    <div class="calendar-bd">
      <div class="one-month" v-for="(oneMonth, index) in monthList">
        <div class="month-hd">{{ oneMonth.year }}年{{ oneMonth.month }}月</div>
        <ul>
          <li
            class="day-cell"
            v-for="item in oneMonth.days"
            @click="useDate(item)"
            :class="{
              avail: item && item.price && item.inventory,
              activated: item === activeItem
            }"
          >
            <template v-if="item">
              <b>{{ item.date }}</b>
              <span v-if="item.price && item.inventory">
                <template v-if="isJifen">{{ item.price }}积分</template>
                <template v-else
                  >&yen;{{
                    $$cent2yuan(
                      item.customerPrice != null
                        ? item.customerPrice
                        : item.price,
                      'full'
                    )
                  }}</template
                >
              </span>
              <small v-if="item.inventory && item.inventory <= 10"
                >剩余{{ item.inventory }}</small
              >
            </template>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {},
  mounted() {},
  data() {
    return {
      monthList: [],
      activeItem: null,
      recent: []
    }
  },
  methods: {
    get6month() {
      const a = []
      const m = this.getDate()
      const recent = []
      // 6个自然月
      for (let i = 0; i < 6; i++) {
        const m1 = this.getDate(m.year, m.month + i, 1) // 当月1日
        const m2 = this.getDate(m.year, m.month + i + 1, 0) // 当月最后一天（即下月1日减一天）
        const days = this.getMonthDays(m1, m2)
        days.forEach(item => {
          if (!item) return
          // 标记价格
          const tmp1 = item.year
          const tmp2 = `0${item.month}`.substr(-2)
          const tmp3 = `0${item.date}`.substr(-2)
          const tmp4 = `${tmp1}-${tmp2}-${tmp3}`
          const mtch = this.availPriceMap[tmp4]
          if (mtch) {
            item.price = mtch.price
            item.inventory = mtch.inventory
            item.customerPrice = mtch.customerPrice
            item.customerType = mtch.customerType
          }

          // 最近3天
          if (recent.length > 3) {
            //ok
          } else if (recent.length === 0) {
            if (
              m.year === item.year &&
              m.month === item.month &&
              m.date === item.date
            ) {
              recent.push(item)
            }
          } else if (recent.length < 3) {
            recent.push(item)
          }
        })
        // 因为前6天可能是首填充的null值
        const d = days[7]
        a.push({
          days,
          year: d.year,
          month: d.month
        })
      }
      this.recent.push(...recent)
      return a
    },
    getDate(iy, im, id) {
      let d
      if (iy !== undefined && im !== undefined && id !== undefined) {
        d = new Date(iy, im - 1, id, 0, 0, 0, 0)
      } else {
        // now
        d = new Date()
      }
      return {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        date: d.getDate(),
        day: d.getDay()
      }
    },
    getMonthDays(m1, m2) {
      const arr = []
      // 以周日为一个星期的开始，对数组进行首位填充
      for (let p = 0; p < m1.day; p++) {
        arr.push(null)
      }
      for (let i = 0; i < m2.date; i++) {
        arr.push({
          year: m1.year,
          month: m1.month,
          date: m1.date + i,
          day: (m1.day + i) % 7, // 0代表星期日
          price: '' // 初次绑定占位符
        })
      }
      return arr
    },
    useDate(item) {
      if (item && item.price && item.inventory) {
        this.activeItem = item
        this.$emit('useDate', item)
        setTimeout(() => {
          this.activeItem = null
        }, 100)
      }
    }
  },
  props: {
    availDatePrice: {
      type: Array,
      default: () => {
        return []
      }
    },
    isJifen: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    availPriceMap() {
      const o = {}
      this.availDatePrice.forEach(item => {
        // useDate格式为YYYY-MM-DD
        o[item.useDate] = item
      })
      return o
    }
  },
  components: {},
  watch: {
    availPriceMap(n, o) {
      this.monthList = this.get6month()
      this.$emit('dftDate', this.recent)
    }
  },
  filters: {
    weekHanz(week) {
      const weekTpl = ['日', '一', '二', '三', '四', '五', '六']
      const a = weekTpl[week]
      return a ? `星期${a}` : ''
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.comwrap {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.calendar-hd {
  margin-top: rem(20px);
  background-color: #fff;
  ul {
    overflow: hidden;
    height: rem(114px);
  }
  li {
    line-height: rem(114px);
    width: rem(107px);
    float: left;
    font-size: rem(26px);
    color: #666666;
    text-align: center;
    &.weekend {
      color: #ff5900;
    }
  }
  @include border(bottom, #dddddd);
}
.calendar-bd {
  flex: 1;
  overflow-y: auto;
  overflow-scrolling: touch;
  background-color: #fff;
}
.one-month {
  &:last-child {
    /*margin-bottom: rem(20px);*/
  }
  &:not(:last-child) {
    @include border(bottom, #dddddd);
  }
  .month-hd {
    height: rem(60px);
    line-height: rem(60px);
    text-align: center;
    color: #666666;
    position: sticky;
    top: 0;
    background-color: #fff;
  }
  ul {
    overflow: hidden;
    padding-bottom: rem(10px);
  }
  .day-cell {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: rem(107px);
    height: rem(116px);
    float: left;
    text-align: center;
    color: #cccccc;
    border-radius: rem(8px);
    overflow: hidden;
    padding: rem(14px) 0;
    &.avail {
      color: #121212;
      &.activated {
        background-image: linear-gradient(to right, #ff7d46, #ff4b4b);
        color: #fff;
      }
    }
    b {
      font-size: rem(32px);
      margin-bottom: rem(8px);
    }
    span {
      font-size: rem(22px);
      margin-bottom: rem(2px);
      word-break: keep-all;
    }
    small {
      font-size: rem(18px);
      color: #ff5900;
    }
  }
}
</style>
